<div class="self-exclusion-main-container">
  <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
    <div class="self-exclusion-item-row" *ngSwitchCase="'wettarena'">
      {{ 'wa_self_limit_text_20' | t }}
    </div>
    <div class="self-exclusion-item-row" *ngSwitchCase="'b500'">
      {{ 'wa_self_limit_text_20' | t }}
    </div>
    <div class="self-exclusion-item-row" *ngSwitchDefault>
      {{ 'b3000_self_limit_text_20' | t }}
    </div>
  </ng-container>

  <div class="list-item-row">
    <ul class="unorder-list-game">
      <li>{{ 'b3000_Problematic_game' | t }}</li>
      <li>{{ 'b3000_Financial_problems' | t }}</li>
    </ul>
  </div>

  <div class="self-exclusion-item-row">
    {{ 'b3000_self_limit_text_21' | t }}
  </div>
  <form class="example-form" [formGroup]="accountLockData">
    <div class="self-exclusion-dropdown-container">
      <dropdownb3
        [fData]="period"
        [fDataValueKey]="'AcountLockDayId'"
        [fDataViewKey]="'AcountLockDay'"
        fDefaultSelectText="{{ 'b3000_Select_Period' | t }}"
        fPlaceholder="{{ 'Period' | t }}"
        formControlName="lockDay"
        [(ngModel)]="selectedPeriod"></dropdownb3>
    </div>
    <div class="self-exclusion-dropdown-container">
      <dropdownb3
        [fData]="reason"
        [fDataValueKey]="'AcountLockId'"
        [fDataViewKey]="'LockReason'"
        fDefaultSelectText="{{ 'b3000_Select_Reason' | t }}"
        fPlaceholder="{{ 'Reason' | t }}"
        formControlName="lockReason"
        fextraClass="size-sm"></dropdownb3>
    </div>
    <div class="self-exclusion-dropdown-container" *ngIf="selectedPeriod">
      <inputb3 fErrorText="{{ 'Required' | t }}" fPlaceholder="{{ 'b3000_Confirm_with_password' | t }}" fInputType="password"></inputb3>
    </div>
    <div class="alert-container" *ngIf="selectedPeriod == 98">
      {{ 'b3000_self_limit_text_22' | t }}
    </div>
    <div class="self-exclusion-dropdown-container">
      <div class="btn colored register-button save-changes-button" (click)="submitAccountLockDatas()">
        <div class="btn-text">{{ 'b3000_save_change' | t }}</div>
      </div>
    </div>
  </form>
</div>

<div class="txt-hold-forgot-password" *ngIf="false">
  <h2>{{ 'Account_Lock' | t }}</h2>
  <div class="bgGray">
    <p style="margin-left: 10px; margin-bottom: 5px">
      {{ 'Please_specify_how_many_day_you_would_like_to_lock_your_account2' | t }}
    </p>

    <p style="margin-left: 10px">
      {{ 'Please_specify_how_many_day_you_would_like_to_lock_your_account3' | t }}
    </p>

    <p style="margin-top: 15px; margin-left: 10px; font-size: small">
      <b>{{ 'Select_the_desired_period_of_your_self_lock' | t }}</b>
    </p>
    <p style="margin-bottom: 15px; margin-left: 10px; font-size: small; margin-top: 5px">
      <b>{{ 'Select_the_desired_period_of_your_self_lock2' | t }}</b>
    </p>
  </div>

  <div style="display: flex; flex-direction: row">
    <div style="display: flex; flex-direction: column; justify-content: space-around; margin-left: 20px">
      <p>
        <b>{{ 'Reason' | t }} :</b>
      </p>
      <p>
        <b>{{ 'Period' | t }}:</b>
      </p>
    </div>
    <div style="margin-left: 15px">
      <form class="example-form" [formGroup]="accountLockData">
        <mat-form-field class="example-full-width">
          <mat-label>{{ 'Please_Select' | t }}</mat-label>
          <mat-select required formControlName="lockReason">
            <div class="accountLock-mat-option-panel">
              <mat-option class="accountLock-mat-option-text" value="{{ reason.AcountLockId }}" *ngFor="let reason of reason">{{ reason.LockReason }}</mat-option>
            </div>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-label>{{ 'Please_Select' | t }} </mat-label>
          <mat-select required formControlName="lockDay">
            <mat-option value="{{ period.AcountLockDayId }}" *ngFor="let period of period">{{ period.AcountLockDay }}</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </div>
  <div>
    <button mat-raised-button class="forgot-password-submit-button" (click)="submitAccountLockDatas()" [disabled]="!accountLockData.valid">
      {{ 'Account_Lock' | t }}
    </button>
  </div>

  <div class="bgGray bgGray-h">
    <p style="margin-left: 5px; margin-top: 10px">
      <button mat-button style="background-color: #e7e9e7" (click)="openDialog()">
        <h2 style="text-decoration: underline">{{ 'Ask' | t }}</h2>
      </button>
      {{ 'AskToUs' | t }}
    </p>
  </div>
</div>
